import React, { useContext, useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { NumberContext } from "../content/NumberContext";
import { PuffLoader } from "react-spinners";
import slugify from "react-slugify";
import azercell from "../assets/image/azercell.png";
import gift from "../assets/image/gift.gif";
import translations from "../data/langData";
import { LanguageContext } from "../context/LanguageContext";
import phoneGift from "../assets/image/phone.gif";
import axios from "axios";
const Numbers = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

 const [select,setSelect] = useState('asc')
  const { number } = useParams();
  const numberSplit = number.split("-")[0];
  const numberSplitName = number.split("-")[1];

  const [pageData, setPageData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const perPage = 30;
  useEffect(() => {
    axios
      .get(
        `https://mynumber.az/api/numbers.php?page=${currentPage}&mode=${numberSplit}`
      )
      .then((res) => {
        setPageData(res.data.data); // dəyiş: data sənin response formatına uyğun olmalıdır
        setTotalPages(Math.ceil(res.data.total / perPage)); // dəyiş: total sənin apidən gəlməlidir
       
      })
      .catch((err) => {
        console.log("Xəta baş verdi", err);
      });
  }, [currentPage, number,numberSplit,numberSplitName]);

  const generatePagination = (totalPages, currentPage) => {
    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);

      if (currentPage > 3) pages.push("startDots");

      for (let i = currentPage - 1; i <= currentPage + 1; i++) {
        if (i > 1 && i < totalPages) pages.push(i);
      }

      if (currentPage < totalPages - 2) pages.push("endDots");

      pages.push(totalPages);
    }

    return pages;
  };

  const paginationItems = generatePagination(totalPages, currentPage);

  return (
    <>
      <section className="numbers my-5">
        <h1 className="text-center fs-3">
          {numberSplitName.toUpperCase() == "HEDIYYELI"
            ? "HƏDİYYƏLİ"
            : numberSplitName.toUpperCase()}{" "}
          {t.numbers.toUpperCase()}
        </h1>
        <div className="container">
          <div className="row">
            <div className="d-flex justify-content-end align-items-center pe-3">
              <span className="mx-2">{t.price}</span>
              <select 
               name="" 
               id="" 
               className="p-2"
               style={{border:"none",borderRadius:"8px"}}
               value={select}
               onChange={(e)=>setSelect(e.target.value)}
               >
                <option value="asc">{t.sort1}</option>
                <option value="desc">{t.sort2}</option>
              </select>
            </div>
            {pageData.length == 0 ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "50vh" }}
              >
                <PuffLoader color="#2abee7" size={70} />
              </div>
            ) : (
              [...pageData].sort((a,b)=>{
                if (select == "asc") {
                   return a.price - b.price
                } else {
                  return b.price - a.price
                }
              }).map((item) => {
                const showImg = item.dq == 0 && item.gb == 0;
                return (
                  <NavLink
                    to={`/order/${slugify(`${item.id}-${item.sim}`)}`}
                    // data-aos="fade-up"
                    className="text-dark mb-3 mt-3"
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      className="col-lg-12  col-sm-12 col-12 g-3"
                      key={item.id}
                    >
                      <div
                        className="numberSection d-flex justify-content-between"
                        style={{ background: "#fff" }}
                      >
                        <div className="outline">
                          <div className="d-flex justify-content-between align-items-center p-2">
                            <div>
                              <p
                                className="text-center ms-2 fs-4 text-dark "
                                style={{ margin: "0" }}
                              >
                                <img
                                  src={azercell}
                                  alt=""
                                  className="img-fluid"
                                  style={{ width: "30px" }}
                                />{" "}
                                +994 {item.sim}
                              </p>
                            </div>
                            <div>
                              {" "}
                              <i
                                className="fa-solid fa-square-check me-2"
                                style={{ color: "rgb(152 0 255)" }}
                              ></i>
                              <span>
                                {item.fuck == 0 ? t.fuck : "Fakturalı"}
                              </span>
                            </div>
                            <div className={`${item.dq == 0 && "d-none"}`}>
                              <span>
                                <i
                                  className="fa-solid fa-clock me-2"
                                  style={{ color: "rgb(152 0 255)" }}
                                ></i>
                                {item.dq} dq
                              </span>
                            </div>
                            <div className={`${item.gb == 0 && "d-none"}`}>
                              <span>
                                <i
                                  className="fa-solid fa-globe me-2"
                                  style={{ color: "rgb(152 0 255)" }}
                                ></i>
                                {item.gb} gb
                              </span>
                            </div>
                          </div>
                        </div>
                        <p
                          className="text-center ms-2 fs-4 "
                          style={{ margin: "0" }}
                        >
                          <img
                            src={azercell}
                            alt=""
                            className="img-fluid"
                            style={{ width: "30px" }}
                          />{" "}
                          +994 {item.sim}
                        </p>
                        <span className="fs-4" style={{ color: "#000" }}>
                          {numberSplit == "5" && (
                            <img
                              src={phoneGift}
                              alt=""
                              className={`img-fluid me-2 ${
                                showImg && "d-none"
                              }`}
                              style={{ width: "45px" }}
                            />
                          )}
                          <img
                            src={gift}
                            alt=""
                            className={`img-fluid me-2 ${showImg && "d-none"}`}
                            style={{ width: "40px" }}
                          />
                          {item.price} ₼
                        </span>
                      </div>
                    </div>
                  </NavLink>
                );
              })
            )}
            <div className="buttons d-flex justify-content-center align-items-center">
              <div className="pagination-buttons d-flex justify-content-center mt-4 flex-wrap">
                {paginationItems.map((item, index) => {
                  if (item === "startDots" || item === "endDots") {
                    return (
                      <span key={index} className="mx-2">
                        ...
                      </span>
                    );
                  }

                  return (
                    <button
                      key={index}
                      onClick={() => setCurrentPage(item)}
                      className={`mx-1 px-3 py-2 ${
                        currentPage === item ? "active-page" : ""
                      }`}
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        backgroundColor:
                          currentPage === item ? "#2abee7" : "#fff",
                        color: currentPage === item ? "#fff" : "#000",
                        fontWeight: currentPage === item ? "bold" : "normal",
                        cursor: "pointer",
                      }}
                    >
                      {item}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Numbers;
